import { render, staticRenderFns } from "./modal-validasi-pengiriman.vue?vue&type=template&id=422980c4&"
import script from "./modal-validasi-pengiriman.vue?vue&type=script&lang=js&"
export * from "./modal-validasi-pengiriman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports